export default __webpack_public_path__ + "static/media/blue5.7750858d.png";